import { defaultInstitutionStatisticsPlugin } from './institution-statistics/default-institiiution-statistics-plugin.js';
import { defaultInvoiceManagementPlugin } from './invoice-management/default.js';
import { defaultInvoiceUserInvoicesTablePlugin } from './invoice-user-invoices-table/invoice-user-invoices-table-default.js';
import { defaultParticipationOverviewPlugin } from './participation-overview/default.js';
import { defaultPaymentPlugin } from './payment/default.js';
import { registerAndActivatePlugin } from './plugin.js';
import { defaultRegistrationProductEntryRequirementsPlugin } from './product-entry-requirements/product-entry-requirements-default.js';
import { defaultRegistrationProductWaitinglistPriorityRulesPlugin } from './product-waitinglist-priority-rules/product-waitinglist-priority-rules-default.js';
import { defaultRegistrationUserDataPlugin } from './registration-user-data/default.js';
import { defaultRegistrationStammdatenPlugin } from './stammdaten/default.js';
import { defaultWorkshopParticipationExportPlugin } from './workshop-participation-export/workshop-participation-export-default.js';

export const initDefaultPlugins = () => {
  registerAndActivatePlugin(defaultRegistrationUserDataPlugin, 'default');
  registerAndActivatePlugin(defaultRegistrationStammdatenPlugin, 'default');
  registerAndActivatePlugin(defaultPaymentPlugin, 'default');
  registerAndActivatePlugin(defaultInvoiceManagementPlugin, 'default');
  registerAndActivatePlugin(defaultInvoiceUserInvoicesTablePlugin, 'default');
  registerAndActivatePlugin(defaultWorkshopParticipationExportPlugin, 'default');
  registerAndActivatePlugin(defaultInstitutionStatisticsPlugin, 'default');
  registerAndActivatePlugin(defaultParticipationOverviewPlugin, 'default');
  registerAndActivatePlugin(defaultRegistrationProductEntryRequirementsPlugin, 'default');
  registerAndActivatePlugin(defaultRegistrationProductWaitinglistPriorityRulesPlugin, 'default');
};
